import { Component, OnInit } from '@angular/core';
import { SubastasService } from '../_services';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { templateJitUrl, analyzeNgModules } from '@angular/compiler';

@Component({
  selector: 'app-resumen-precios',
  templateUrl: './resumen-precios.component.html',
  styleUrls: ['./resumen-precios.component.css']
})
export class ResumenPreciosComponent implements OnInit {
  public subastas: Array<object> = [];
  public periodoActual: any;
  filtrarForm: FormGroup;
  dropdownSettings = {};
  mesList = [];
  anhoList = [];
  periodoList: Array<object> = [];
  periodoFiltradoList: Array<object> = [];
  mes: any;
  anho: any;
  selectedMes = [];
  selectedAnho = [];
  loading = false;
  anhoActual: any;
  idPeriodo: any;
  constructor(private subastasService: SubastasService,
    public route: ActivatedRoute) { }

  ngOnInit() {
    // inicializamos mes y anho
    this.mes = {
      item_id: -1,
      item_text: ''
    };
    this.anho = {
      item_id: -1,
      item_text: ''
    };
    this.mesList = [
      { item_id: 1, item_text: 'Enero' },
      { item_id: 2, item_text: 'Febrero' },
      { item_id: 3, item_text: 'Marzo' },
      { item_id: 4, item_text: 'Abril' },
      { item_id: 5, item_text: 'Mayo' },
      { item_id: 6, item_text: 'Junio' },
      { item_id: 7, item_text: 'Julio' },
      { item_id: 8, item_text: 'Agosto' },
      { item_id: 9, item_text: 'Septiembre' },
      { item_id: 10, item_text: 'Octubre' },
      { item_id: 11, item_text: 'Noviembre' },
      { item_id: 12, item_text: 'Diciembre' }
    ];
    this.anhoActual = new Date().getFullYear();
    for (let i = 0; i < 6; i++) {
      this.anhoList.push({
        item_id: this.anhoActual - i,
        item_text: (this.anhoActual - i).toString()
      });
    }
    this.route.paramMap.subscribe(params => {
      this.idPeriodo = params.get('id');
      this.getPeriodos();
    });
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Todos',
      unSelectAllText: 'Desmarcar todos',
      itemsShowLimit: 1
    };
  }

  public getSubastas(periodo) {
    if (periodo !== undefined) {
      this.periodoActual = periodo;
      this.mes = {
        item_id: periodo['mes'],
        item_text: this.mesList[periodo['mes'] - 1].item_text
      };
      this.anho = {
        item_id: periodo['anho'],
        item_text: periodo['anho'].toString()
      };
      this.selectedMes = [this.mes];
      this.selectedAnho = [this.anho];
      this.filtrarPeriodos(this.mes['item_id'], this.anho['item_id']);
      this.subastasService
        .getSubastasByPeriodo(periodo.id)
        .subscribe((data: Array<object>) => {
          this.subastas = data;
          this.loading = true;
        });
    }
  }

  public getPeriodoActual() {
    this.subastasService.getUltimoPeriodo().subscribe((data: Array<object>) => {
      this.getSubastas(data[0]);
    });
  }

  public getPeriodos() {
    this.subastasService.getPeriodos().subscribe((data: Array<object>) => {
      this.periodoList = data;
      if (this.idPeriodo == null) {
        this.getPeriodoActual();
      } else {
        this.periodoList.forEach((periodo) => {
          if (periodo['id'] === Number(this.idPeriodo)) {
            this.getSubastas(periodo);
          }
        });
      }
    });
  }

  onMesSelect(item: any) {
    this.mes = item;
    this.filtrarPeriodos(this.mes['item_id'], this.anho['item_id']);
  }
  onAnhoSelect(item: any) {
    this.anho = item;
    this.filtrarPeriodos(this.mes['item_id'], this.anho['item_id']);
  }

  filtrarPeriodos(mes, anho) {
    // este metodo obtiene localmente los periodos, de modo a no hacer un request cada vez que filtramos
    this.periodoFiltradoList = [];
    this.periodoFiltradoList = this.periodoList.filter(
      periodo => periodo['mes'] === mes && periodo['anho'] === anho
    );
  }

  public separadorMiles(input) {
    const ret = input ? input.replace(/,/gi, '.') : null;
    return ret;
  }
}
